import Controller from "csi/action/Controller";
import locale from "csi/locale";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import declare from "dojo/_base/declare";

const PRODUCT_HIERARCHY = "ProductHierarchy";

const SelectProductHierarchy = declare(Controller, {

	toWriterRequest() {
		const call = this.inherited<CallMethod>(arguments);
		const fd = this.m_formData;
		const productHierarchyField = fd.getField(PRODUCT_HIERARCHY);
		if (xml.isValidURL(productHierarchyField.getValue())) {
			const lastField = fd.getFields().pop();
			call.addParameter("ProductHierarchyFolder", xml.ATTR_REF, lastField.getValue());
		}

		return call;
	},
});

export = SelectProductHierarchy;